import { useContext, useState } from "react";
import styles from "./ContactRow.module.css";
import DataContext from "../store/data-context";

export default function ContactRow(props) {
  const [isCopying, setIsCopying] = useState(false);

  const [isMobile, setIsMobile] = useState(props.isMobile ? false : true);

  const dataCtx = useContext(DataContext);
  const copyTextToClipboard = () => {
    navigator.clipboard.writeText(props.info);
    setIsCopying(true);
    setTimeout(() => {
      setIsCopying(false);
    }, [1000]);
  };

  return (
    <div
      className={`${styles[`contact-row`]} ${
        styles[isMobile && `mobile-row`]
      } `}
      onClick={isCopying ? () => {} : copyTextToClipboard}
    >
      <img
        src={props.icon}
        alt="Icon."
        className={`${styles[`contact-icon`]} ${
          styles[isMobile && `mobile-icon`]
        }`}
      />
      <div className={`${styles[`contact-text`]}`}>
        {isCopying ? dataCtx.pageData.contact.copy : props.info}
      </div>
    </div>
  );
}
